import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

axios.defaults.withCredentials = true;

export default function Login() {
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function submit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await axios.post("/api/auth/login", {
        username: "admin",
        password,
      });

      nav("/", { replace: true });
    } catch (e) {
      setError(e?.response?.data?.message || "Ошибка входа");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen grid place-items-center bg-[#F6F7FB] px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-[420px] bg-white rounded-[18px] border border-[#E5E7EB] shadow-[0_18px_40px_rgba(0,0,0,0.12)] p-6"
      >
        <h1 className="text-[22px] font-semibold text-[#111827]">
          Вход в админку
        </h1>

        <div className="mt-5 grid gap-3">
          <input
            type="password"
            placeholder="Пароль"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="h-11 px-4 rounded-[14px] border border-[#D6D9E0] outline-none focus:border-[#2B7CFF]"
          />

          {error && (
            <div className="rounded-[14px] border border-[#FFD0D0] bg-[#FFF1F1] p-3 text-[12px] text-[#B91C1C]">
              {error}
            </div>
          )}

          <button
            disabled={loading}
            className="h-11 rounded-full bg-[#2B7CFF] text-white font-semibold hover:brightness-95 transition disabled:opacity-60"
          >
            {loading ? "Входим…" : "Войти"}
          </button>
        </div>
      </form>
    </div>
  );
}
